import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import awsExports from "./aws-exports";
import mapboxgl from "mapbox-gl";
import { observer } from "mobx-react";
import { AuthenticatorView } from "./app/auth/views/AuthenticatorView";
import { SharedProjectMapPage } from "./app/pages/map/SharedProjectMapPage";
import { DemonstratorPage } from "./app/demonstrator/DemonstratorPage";
import { CommentRedirectPage } from "./app/pages/comment/CommentRedirectPage";
import { AdminIntegrationsPage } from "./app/admin/views/integrations/AdminIntegrationsPage";
import { AccountHomePage } from "./app/account/views/home/AccountHomePage";
import { AccountUsersPage } from "./app/account/views/users/AccountUsersPage";
import { AccountProjectsPage } from "./app/account/views/projects/AccountProjectsPage";
import { AccountIntegrationsPage } from "./app/account/views/integrations/AccountIntegrationsPage";
import { AdminToolsPage } from "./app/admin/views/tools/AdminToolsPage";
import { useStores } from "./app/shared/stores/RootStore";
import { AdminProjectsPage } from "./app/admin/views/projects/AdminProjectsPage";
import { MapPage } from "./app/pages/map/MapPage";
import { OsaWayRedirectPage } from "./app/osaway/views/OsaWayRedirectPage";
import { AdminUsersPage } from "./app/admin/views/users/AdminUsersPage";
import { AdminAccountsPage } from "./app/admin/views/accounts/AdminAccountsPage";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_KEY!;

Amplify.configure(awsExports as any);

export const appRoutes = {
  home: () => `/`,
  project: (id = ":projectId") => `/project/${id}`,
  comment: (id = ":commentId") => `/comment/${id}`,
  osaWay: (id = ":osaWayId") => `/osa-way/${id}`, // TODO add page to redirect this to the project page
  account: (id = ":accountId") => `/account/${id}`,
  accountUsers: (id = ":accountId") => `/account/${id}/users`,
  accountProjects: (id = ":accountId") => `/account/${id}/projects`,
  accountIntegrations: (id = ":accountId") => `/account/${id}/integrations`,
  demonstrator: () => `/demonstrator`,
  admin: () => `/admin`,
  adminIntegrations: () => `/admin/integrations`,
  adminTools: () => `/admin/tools`,
  adminProjects: () => `/admin/projects`,
  adminUsers: () => `/admin/users`,
  adminAccounts: () => `/admin/accounts`,
};

export const publicRoutes = {
  project: (id = ":projectId") => `/shared/project/${id}`,
  signUp: () => "/sign-up",
};

function App() {
  const { authStore } = useStores();

  return (
    <BrowserRouter>
      <Routes>
        {authStore.isAuthenticated ? (
          <>
            <Route index element={<MapPage isHome />} />
            <Route path={appRoutes.project()} element={<MapPage />} />
            <Route
              path={appRoutes.demonstrator()}
              element={<DemonstratorPage />}
            />
            <Route
              path={appRoutes.comment()}
              element={<CommentRedirectPage />}
            />
            <Route path={appRoutes.osaWay()} element={<OsaWayRedirectPage />} />

            {/* Account backoffice */}
            <Route path={appRoutes.account()} element={<AccountHomePage />} />
            <Route
              path={appRoutes.accountUsers()}
              element={<AccountUsersPage />}
            />
            <Route
              path={appRoutes.accountProjects()}
              element={<AccountProjectsPage />}
            />
            <Route
              path={appRoutes.accountIntegrations()}
              element={<AccountIntegrationsPage />}
            />

            {/* SuperAdmin backoffice */}
            {authStore.isSuperAdmin && (
              <>
                <Route path={appRoutes.admin()} element={<AdminToolsPage />} />
                <Route
                  path={appRoutes.adminTools()}
                  element={<AdminToolsPage />}
                />
                <Route
                  path={appRoutes.adminIntegrations()}
                  element={<AdminIntegrationsPage />}
                />
                <Route
                  path={appRoutes.adminProjects()}
                  element={<AdminProjectsPage />}
                />
                <Route
                  path={appRoutes.adminUsers()}
                  element={<AdminUsersPage />}
                />
                <Route
                  path={appRoutes.adminAccounts()}
                  element={<AdminAccountsPage />}
                />
              </>
            )}
          </>
        ) : (
          <>
            <Route path="*" element={<AuthenticatorView />} />
          </>
        )}

        {/* Routes to resources shared by the user */}
        <Route
          path={publicRoutes.project()}
          element={<SharedProjectMapPage />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default observer(App);
